<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title>UNIDADES</template>
      <template #actions>
        <span class="q-ml-sm text-brand-5">
          - Selecione as unidades para que tenha acesso
        </span>
      </template>
    </PageHeader>
    <p class="text-h7 text-brand-4 text-weight">
      Minha Região: {{ minhaRegiao }}
    </p>

    <div>
      <q-linear-progress size="xs" v-if="loading" indeterminate />
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        row-key="id"
        v-model:pagination="pagination"
        selection="multiple"
        v-model:selected="selected"
        hide-pagination
        hide-bottom
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos as unidades</span
          >
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              {{ props.row.id }}
            </q-td>
            <q-td>
              {{ props.row.name }}
            </q-td>
            <q-td>
              {{ props.row.code }}
            </q-td>
            <q-td>
              <q-toggle
                v-model="props.selected"
                :val="props.row.id"
                :disable="disable"
                color="primary"
                @click="changeStatus(props.row.id, props.selected)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div>
      <q-linear-progress size="xs" v-if="loading" indeterminate />
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :columns="columns2"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        row-key="id"
        v-model:pagination="pagination"
        selection="multiple"
        v-model:selected="selected"
        hide-pagination
        hide-bottom
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter2"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Unidades Ativas</span
          >
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              {{ props.row.id }}
            </q-td>
            <q-td>
              {{ props.row.name }}
            </q-td>
            <q-td>
              {{ props.row.code }}
            </q-td>
            <q-td>
              <q-btn
                size="sm"
                color="red"
                icon="delete"
                round
                flat
                no-caps
                @click="remover(props.row)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination2.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber2"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "code",
    label: "Região",
    field: "code",
    align: "left",
  },
  {
    name: "ativo",
    label: "Ativo",
    field: "ativo",
    align: "left",
  },
];

const columns2 = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "code",
    label: "Região",
    field: "code",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  setup() {
    // const keycloak = inject("keycloak");
    let filter = ref("");
    let filter2 = ref("");
    const rows = ref([]);
    const rows2 = ref([]);
    const user = ref();
    const disable = ref(true);
    let loading = ref(false);
    const store = useStore();
    const $q = useQuasar();
    const value = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 15,
    });
    const pagination2 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 15,
    });
    const selected = ref([]);
    const minhaRegiao = ref("");

    const getPostos = async (page = 1, per_page = 15) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("adminMultpex/getUnidades", {
          page,
          per_page,
          search: filter.value,
        });

        const responseUser = await store.dispatch(
          "adminMultpex/getUnidadesUser",
          {
            search: filter2.value,
          }
        );
        const auth = await store.dispatch("adminMultpex/auth");

        user.value = auth.data;

        minhaRegiao.value = auth.data.regiao || "";

        selected.value = responseUser.data.results.data;

        rows.value = response.data.results.data;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        disable.value = false;
        loading.value = false;
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar postos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getPostosAtivos = async (page = 1, per_page = 15) => {
      disable.value = true;
      loading.value = true;
      try {
        const responseUser = await store.dispatch(
          "adminMultpex/getUnidadesUser",
          {
            page,
            per_page,
            search: filter2.value,
          }
        );

        rows2.value = responseUser.data.results.data;

        pagination2.value.page = responseUser.data.results.current_page;
        pagination2.value.rowsPerPage = responseUser.data.results.per_page;
        pagination2.value.rowsNumber = responseUser.data.results.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        disable.value = false;
        loading.value = false;
        $q.notify({
          message: "Erro a o encontrar postos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const changeStatus = async (id, event) => {
      disable.value = true;
      try {
        if (!event) {
          await store.dispatch("adminMultpex/ativarUnidade", {
            vendor_id: id,
            id: user.value.id,
          });
          $q.notify({
            message: "Unidade associada com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getPostos(pagination.value.page, pagination.value.rowsPerPage);
          getPostosAtivos();
        } else {
          await store.dispatch("adminMultpex/deletarUnidade", {
            vendor_id: id,
            id: user.value.id,
          });

          $q.notify({
            message: "Unidade desassociada com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getPostos(pagination.value.page, pagination.value.rowsPerPage);
          getPostosAtivos();
        }
      } catch (error) {
        disable.value = false;
        $q.notify({
          message: "Erro a o configurar postos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const remover = async (row) => {
      await store.dispatch("adminMultpex/deletarUnidade", {
        vendor_id: row.id,
        id: user.value.id,
      });

      $q.notify({
        message: "Unidade desassociada com sucesso.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      getPostos(pagination.value.page, pagination.value.rowsPerPage);
      getPostosAtivos();
    };

    watch(
      () => pagination.value.page,
      () => {
        getPostos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filter.value,
      () => {
        getPostos();
      }
    );

    watch(
      () => filter2.value,
      () => {
        getPostosAtivos();
      }
    );

    onMounted(getPostos);
    onMounted(getPostosAtivos);

    return {
      loading,
      filter,
      rows,
      disable,
      columns,
      value,
      changeStatus,
      selected,
      remover,
      pagination,
      pagination2,
      rows2,
      columns2,
      minhaRegiao,
      filter2,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pagesNumber2: computed(() =>
        Math.ceil(pagination2.value.rowsNumber / pagination2.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
</style>
